import { useEffect } from 'react';

/**
 * Displays live coordinates in a fixed bar at the bottom center of the map.
 * Uses pointer-events: none so Leaflet.draw tools are never blocked.
 *
 * @param {React.MutableRefObject} mapInstance - ref holding the L.Map instance
 * @param {boolean} isReady - set true once the map has been initialised
 */
export const useCoordinateTooltip = (mapInstance, isReady) => {
  useEffect(() => {
    if (!isReady) return;
    const map = mapInstance?.current;
    if (!map) return;

    const el = document.createElement('div');
    el.className = 'map-coord-tooltip';
    el.style.display = 'none';
    map.getContainer().appendChild(el);

    const onMouseMove = (e) => {
      const { lat, lng } = e.latlng;
      el.textContent = `${lat.toFixed(5)},  ${lng.toFixed(5)}`;
      el.style.display = 'block';
    };

    const onMouseOut = () => {
      el.style.display = 'none';
    };

    map.on('mousemove', onMouseMove);
    map.on('mouseout',  onMouseOut);

    return () => {
      map.off('mousemove', onMouseMove);
      map.off('mouseout',  onMouseOut);
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, [isReady, mapInstance]);
};